import React, { useState, useCallback, useRef } from "react";
import webui from "@tinqin/tinqin-web-ui";
import { xssFilter } from "../../../common/utils/xssFilter";
import { IComponentProps, IExtractedProps } from "Common/utils/commonTypes";

export const ExpandBox: React.FC<IComponentProps> = props => {
    const [expanded, setExpanded] = useState<boolean>(false);
    const [height, setHeight] = useState<string>("0px");
    const refContent: React.MutableRefObject<HTMLDivElement> = useRef();

    // http://jira.tinqin.com/browse/UGP-978
    const expandArea = useCallback(() => {
        const element: HTMLDivElement = refContent.current;
        if (!expanded) {
            expandContent(element);
            setExpanded(true);
        }
    }, [expanded]);

    const expandContent = (el: HTMLElement) => {
        setHeight(`${el.scrollHeight}px`);
    };

    const styles = {
        transition: "height 0.25s",
        opacity: 1,
        overflow: "hidden",
        height: height
    };

    const data: Record<string, any> = props.data ? props.data.properties || {} : null;
    if (!data) {
        return null;
    }
    const dataProps: IExtractedProps = webui.getUtils().extractComponentProps(props, {
        additionalProps: ["text", "expandedText", "anchorId"]
    });
    const expandedClass: string = expanded ? "tq-expanded" : "";
    const expandableClass: string = dataProps.expandedText === "" ? "" : "tq-expandable";
    return (
        <div
            className="tq-accordion un-source-info-accordion"
            id={dataProps.anchorId ? dataProps.anchorId : null}
        >
            <div className={"tq-section " + expandableClass + " " + expandedClass}>
                <div
                    className="tq-section-header"
                    onClick={expandableClass ? expandArea : undefined}
                >
                    <div className="tq-title">
                        <span
                            className="tq-text-node"
                            dangerouslySetInnerHTML={{
                                __html: xssFilter.process(dataProps.text)
                            }}
                        ></span>
                    </div>
                </div>
                <div className="tq-section-content" style={styles} ref={refContent}>
                    <div className="tq-title">
                        <span
                            className="tq-text-node"
                            dangerouslySetInnerHTML={{
                                __html: xssFilter.process(dataProps.expandedText)
                            }}
                            data-hyperlinks-container={true}
                        ></span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default webui.connectComponent()(ExpandBox);
